export default {
  path: 'agent/:contentType?/:entityId?',
  name: 'starfishAgent',
  component: () => import('../pages/StarfishMcpPage.vue'),
  meta: {
    pageTitle: 'Ask Starfish',
    requiresAuth: true,
    hideSearchFromHeader: false,
    showRightPanel: false,
  },
};
